import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Sayaridunia &middot; Your Journey Awaits</p>
        <h1>Embrace Your Best Life</h1>
        <p className="lede">
          Discover a world of personal development, mindfulness, and travel. Join us as we explore ways to enrich your life and find balance in every journey.
        </p>
        <div className="cta-row">
          <a href="#latest-news" target="_self">
            Latest Trends
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards" id="latest-news">
        <article>
          <h2>Wellness travel shifts toward nervous-system regulation</h2>
          <p>2026's biggest wellness-travel trend moves away from performance-driven wellness toward recovery -- retreats now build programs around breathwork, slow movement, and nature immersion.</p>
        </article>
        <article>
          <h2>Digital detox retreats gain real traction</h2>
          <p>Studies suggest intentional breaks from digital stimulation reduce physiological stress markers, driving demand for retreats built around device-free time.</p>
        </article>
        <article>
          <h2>Wellness tourism on track to exceed $1.4 trillion by 2027</h2>
          <p>Global wellness tourism continues its rapid growth, with mindful, restorative travel experiences leading the expansion.</p>
        </article>
      </section>

      <section className="cards">
        <article>
          <h2>Personal Growth</h2>
          <p>
            Unlock your potential with insights and tips on self-improvement and mindfulness practices that inspire a fulfilling life.
          </p>
        </article>
        <article>
          <h2>Mindfulness Matters</h2>
          <p>
            Discover techniques to cultivate mindfulness and presence, helping you navigate life's challenges with grace and clarity.
          </p>
        </article>
        <article>
          <h2>Travel Inspiration</h2>
          <p>
            Explore breathtaking destinations and travel stories that ignite your wanderlust and encourage you to embark on new adventures.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;